export { default } from "./documentObjectTypesPanel";
